import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

import {
  faDiamondExclamationSolid,
  faTriangleExclamationSolid,
  faCircleExclamationSolid,
  faExclamationSolid,
} from '@/lib/fa'

export enum ViolationWeightType {
  NN = 'NN',
  Penalty = 'PN',
  CompanyPenalty = 'BPN',
  CollectivePenalty = 'ZN',
}

export const getViolationWeightIcon = (
  weight?: string,
): IconDefinition | null => {
  if (!weight) return null

  if (weight.includes(ViolationWeightType.NN)) {
    return faDiamondExclamationSolid
  }
  if (weight.includes(ViolationWeightType.Penalty)) {
    return faCircleExclamationSolid
  }
  if (weight.includes(ViolationWeightType.CompanyPenalty)) {
    return faTriangleExclamationSolid
  }
  if (weight.includes(ViolationWeightType.CollectivePenalty)) {
    return faExclamationSolid
  }

  return null
}
